const isSuccessResponse = (response) =>
	['success', 'Success'].includes(response?.type);

const requestWithActionFallback = async (sendRequest, payloads) => {
	const responses = await payloads.reduce(async (chain, payload) => {
		const state = await chain;

		if (isSuccessResponse(state?.lastResponse)) {
			return state;
		}

		const response = await sendRequest(payload);
		return { lastResponse: response };
	}, Promise.resolve({ lastResponse: null }));

	return responses.lastResponse;
};

export const getTourStatusList = async (sendRequest) => {
	const response = await requestWithActionFallback(sendRequest, [
		{ action: 'get_tour_status_list' },
	]);

	if (!isSuccessResponse(response)) {
		throw new Error(response?.message || 'Unable to fetch tour status list');
	}

	return Array.isArray(response?.data) ? response.data : [];
};

export const saveTourStatus = async (sendRequest, id, status = 1) => {
	if (!id) {
		throw new Error('Tour module id is required to save status');
	}

	const response = await requestWithActionFallback(sendRequest, [
		{ action: 'save_tour_status', id, status },
		{ action: `save_tour_status?id=${id}&status=${status}` },
		{ action: '/save_tour_status', id, status },
		{ action: `/save_tour_status?id=${id}&status=${status}` },
	]);

	if (!isSuccessResponse(response)) {
		throw new Error(response?.message || 'Unable to save tour status');
	}

	return response;
};

export default {
	getTourStatusList,
	saveTourStatus,
};
